import { Box, Stack } from "@mui/material";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import { readEnv } from "@repo/helpers";
import { BodyTextM, BodyTextS, Icons } from "@repo/ui";
import { IconButton } from "gatsby-theme-material-ui";
import { type FC } from "react";
import { dateTimeFormat } from "../../functions/dates";

export interface DownloadProps {
	name: string;
	dateCreated: Date;
	fileSize?: number;
	mimeType: string;
	infoIcon?: boolean;
	tagNew?: boolean;
	downloadPath?: string;
	isExternalUrl?: string;
}

const Download: FC<DownloadProps> = ({
	name,
	dateCreated,
	fileSize,
	mimeType,
	infoIcon,
	tagNew,
	downloadPath,
	isExternalUrl,
}) => {
	const formattedSize =
		fileSize !== undefined
			? fileSize > 999
				? `${fileSize.toString().slice(0, -3)}kB`
				: `${fileSize}B`
			: "";

	return (
		<Stack
			direction="row"
			sx={{
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				alignItems: "center",
			}}
			spacing={4}
		>
			<IconButton
				to={
					isExternalUrl
						? downloadPath
						: `${readEnv("GATSBY_API_BASE_URL")}/${downloadPath}`
				}
				color="primary"
				download
				target="_blank"
				disabled={!downloadPath}
			>
				<Icons.Download
					sx={{ width: "1.6rem", height: "2rem" }}
					color="inherit"
				/>
			</IconButton>
			<Stack sx={{ flexGrow: 1, flexBasis: "50%", minWidth: 0 }}>
				<BodyTextM
					sx={{
						overflow: "hidden",
						color: "primary.main",
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
					}}
				>
					<Link
						href={
							isExternalUrl
								? downloadPath
								: `${readEnv("GATSBY_API_BASE_URL")}/${downloadPath}`
						}
						target="_blank"
						variant="light"
					>
						{name}
					</Link>

					<Box component="span" sx={{ whiteSpace: "nowrap" }}>
						&nbsp;
						{infoIcon && (
							<Icons.Info
								color="text"
								sx={{
									width: "1.8rem",
									height: "1.8rem",
									ml: 2,
								}}
							/>
						)}
						{tagNew && <Chip label="Nové" sx={{ mb: 1, ml: 2 }} />}
					</Box>
				</BodyTextM>
				<BodyTextS mb={0} light>
					{dateCreated && dateTimeFormat.format(new Date(dateCreated))} (
					{fileSize ? `${formattedSize}, ` : ""}
					{mimeType.replace(/application\//g, "")})
				</BodyTextS>
			</Stack>
		</Stack>
	);
}

export default Download;
